// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__gISKY","loader":"style_loader__UljTU"};